import React from 'react'
import styles from './styles.module.css'

function PrimaryCategory ({ record }) {
  const primaryCategory =
    record?.primaryCategories?.length > 0 ? record.primaryCategories[0] : 'N/A'

  return (
    <div className={styles.PrimaryCategoryContainer}>
      <span className={styles.PrimaryCategoryLabel}>Primary category</span>
      <span
        className={
          primaryCategory === 'N/A'
            ? styles.PrimaryCategoryNA
            : styles.PrimaryCategoryValue
        }
      >
        {primaryCategory}
      </span>
    </div>
  )
}

export default PrimaryCategory
